/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListUserDeactivationsOptions,
  ListUserDeactivationsResponses,
} from '../types/ListUserDeactivations'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Returns each user's latest deactivation request, i.e. their current status. Users with no deactivation history are absent. Ordered by request creation time, newest first. Integrators only see users of their own tenant, unless that tenant is global.
 * @summary Get the current deactivation status across all users (admin, integrator)
 * {@link /v1/user/deactivations}
 */
export function listUserDeactivations<ThrowOnError extends boolean = true>(
  options: Options<ListUserDeactivationsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListUserDeactivationsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user/deactivations',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListUserDeactivationsResponses, ThrowOnError>>,
  )
}
